/**
 * defa.models.Invitation
 * The DEFA Invitation Model.
 * @version 1.0.0
 * @author Benjamin Rusten
 */

import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';


const apiHost = defa.vars.apiHost;

const api = {
	invitations   : apiHost + '/invitations',
};

const Invitation = Model.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	urlRoot: api.invitations,
	
	defaults: {
		email: '',
		owner: {},
		subscriptions: []
	},
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
		/**
		 * Separates objects and stores information in the channel.
		 * @overwrite
		 *
		 * @param  {Object} response  The server response, which can be a bundle of linked objects.
		 * @return {Object}           The parsed response, now only containing the correct variables for an Invitation.
		 */
	parse: function( response ) {
		return response
	},
	
});

export default Invitation;
